import axios from "axios";

// mode based
export const apiOrigins = ["https://api.omtanken.se/", "https://api-test.vasterleden.se/", "http://127.0.0.1:8000/"];
export const auth = [
  "Token d76439eb345ed83180669bf173e60504cad8c709",
  "Token d76439eb345ed83180669bf173e60504cad8c709",
  "Token d76439eb345ed83180669bf173e60504cad8c709",
];

export const mode = 0; // 0: skarp, 1: api-test, 2: localhost
export const api = axios.create({
  baseURL: apiOrigins[mode] + "api/",
  withCredentials: true,
  headers: {
    Authorization: auth[mode],
    "Content-Type": "application/json",
  },
});

export const fileApi = axios.create({
  baseURL: apiOrigins[mode] + "api/",
  withCredentials: true,
  headers: {
    Authorization: auth[mode],
    "Content-Type": "multipart/form-data",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const helpdeskApi = axios.create({
  headers: {
    Authorization: "Bearer AnBPQ5g46aYy8fJxGVClB3TA711qMArIdyr13uUIb09Q5CxYFXCo6mxdf0xxNIhr",
    // Authorization: "Bearer 53rGFFx8lsyzNWu6XCkpEUKoFgx0l5sG2Ej4xdFS3-mRjJqSLw6BoPGyENUrop85",
    "Content-Type": "application/json",
  },
});

export const helpdeskPublicApi = axios.create({
  headers: {
    Authorization: "Bearer 53rGFFx8lsyzNWu6XCkpEUKoFgx0l5sG2Ej4xdFS3-mRjJqSLw6BoPGyENUrop85",
    "Content-Type": "application/json",
  },
});

export function setAuth(authorization) {
  if (authorization) {
    api.defaults.headers.Authorization = authorization;
    fileApi.defaults.headers.Authorization = authorization;
  } else {
    api.defaults.headers.Authorization = auth[mode];
    fileApi.defaults.headers.Authorization = auth[mode];
  }
}
